import {useCallback, useState} from 'react'

interface NavigationConfirmationState {
  isOpen: boolean
  pendingAction: (() => void) | null
}

export const useNavigationConfirmation = () => {
  const [confirmState, setConfirmState] = useState<NavigationConfirmationState>({
    isOpen: false,
    pendingAction: null
  })

  const requestConfirmation = useCallback((action: () => void) => {
    setConfirmState({
      isOpen: true,
      pendingAction: action
    })
  }, [])

  const handleConfirm = useCallback(() => {
    setConfirmState((prev) => {
      if (prev.pendingAction) {
        prev.pendingAction()
      }
      return {isOpen: false, pendingAction: null}
    })
  }, [])

  const handleCancel = useCallback(() => {
    setConfirmState({isOpen: false, pendingAction: null})
  }, [])

  return {
    isConfirmationOpen: confirmState.isOpen,
    requestConfirmation,
    handleConfirm,
    handleCancel
  }
}
